import { render, staticRenderFns } from "./HeadYtd.vue?vue&type=template&id=031cc2e2"
import script from "./HeadYtd.vue?vue&type=script&lang=js"
export * from "./HeadYtd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports